const MONTH = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']

export default function (date) {
    return date.getDate() + ' ' + MONTH[date.getMonth()] + ' ' + date.getFullYear()
}
